import { Box, BoxProps } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import TableSection from '../../sections/TableSection/TableSection';

interface Props extends BoxProps {}

export const SubscriptionTable = ({ ...props }: Props) => {
    const mainCategories = {
        MOZLIWOSCI_I_KANALY_SPRZEDAZY: 'Możliwości i kanały sprzedaży',
        CROSS_BORDER: 'Cross-border',
        WYGLAD_SKLEPU: 'Wygląd sklepu',
        SPRZEDAZ_I_ZAMOWIENIA: 'Sprzedaż i zamówienia',
        OBSLUGA_KLIENTA_I_PANELU: 'Obsługa klienta i panelu',
        MAGAZYNY: 'Magazyny',
        LOGISTYKA: 'Logistyka',
        ZWROTY_I_REKLAMACJE: 'Zwroty i reklamacje',
        PLATNOSCI_I_ROZLICZENIA: 'Płatności i rozliczenia',
        MARKETING: 'Marketing',
        STATYSTYKI_I_ANALITYKA: 'Statystyki i analityka',
        BEZPIECZENSTWO: 'Bezpieczeństwo',
        B2B: 'B2B',
    };

    const valuesName = {
        START: 'Start',
        BUSINESS: 'Business',
        EXPERT: 'Expert',
        ENTERPRISE: 'Enterprise',
        INDIVIDUAL: 'Individual',
    };

    const Plus = <CheckIcon fontSize={'lg'} color={'#1AAC7A'} />;
    const Minus = (
        <>
            <span className="table__minus">-</span>
        </>
    );

    const tableSection = [
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż omnichannel - wielokanałowa',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż na marketplaces',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż międzynarodowa (cross-border)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż stacjonarna',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż subskrypcyjna',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż produktów cyfrowych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Sprzedaż produktów personalizowanych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Możliwości i kanały sprzedaży',
            name: 'Gotowe integracje',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Integracje z marketplaces i porównywarkami',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Lokalne metody płatności i wysyłki',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Zgodność z wymogami UE',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Moduł tłumaczeń automatycznych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Obsługa wielu wersji językowych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Obsługa wielu walut',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Cross-border',
            name: 'Moduł do automatycznego wyliczania stawek VAT OSS',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Gotowe i darmowe szablony sklepu z możliwością personalizacji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Composer - elastyczny moduł do skomponowania własnego szablonu',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Możliwość przygotowania indywidualnego szablonu strony',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Sklep dostosowany do urządzeń mobilnych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Personalizacja grafik i banerów - samodzielnie lub na zlecenie',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Pełna edycja treści na stronach sklepu ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Karta produktu i przeglądanie informacji o towarze',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Galeria produktu na karcie - różne wersje do wyboru, zdjęcia i filmy',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Specjalne oznaczenia produktów w promocji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Możliwość tworzenia kolekcji i zestawów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Szybkie zakupy z karty produktu (express checkout i 1-click) ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Obsługa wielu list zakupowych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Proste wyszukiwanie towarów i wyświetlenie listy produktów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Moduł bloga i aktualności',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Wygląd sklepu',
            name: 'Paski informacyjne',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Filtrowanie, sortowanie i porównywanie towarów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Grupowa edycja towarów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Zaawansowane zarządzanie cenami',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Indywidualne i grupowe rabaty dla klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Zarządzanie parametrami towarów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Kategorie produktów i marek',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Grupowanie wariantów towarów po dowolnym parametrze',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Obsługa rozmiarów i wagi',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Prezentowanie jednostek miar',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Zapytanie o dostępność produktu',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Tworzenie list życzeń z możliwością udostępnienia',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Prosty i szybki proces składania zamówień',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Jednokrokowy lub wielokrokowy procesu składania zamówienia  (do wyboru)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Rozwiązania express checkout - zakup jednym kliknięciem',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Weryfikacja stanów magazynowych podczas składania zamówienia',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Możliwość oznaczania zamówień jako opłacone, wysłane, dostarczone itp.',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Statusy realizacji zamówienia i sposób informowania o zmianie statusu zamówienia',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Ustawienia powiadomień i wiadomości automatycznych (np. potwierdzenie zamówienia, wysyłka)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Dropshipping i cross-docking',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Sprzedaż i zamówienia',
            name: 'Wybór opcji i ilości towaru',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Zaawansowany panel klienta do zarządzania całością sklepu i integracji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Multishop - możliwość obsługi wielu sklepów w jednym panelu',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Konfiguracja ustawień ogólnych sklepu (np. waluta, język, stawki podatkowe)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Zarządzanie użytkownikami panelu',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Zarządzanie klientami (CRM)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Zaawansowana wyszukiwarka klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Narzędzie do samodzielnego importu i eksportu klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Zaawansowana wyszukiwarka zamówień ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Możliwość ręcznego wprowadzania zamówień ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Strefa pytań i odpowiedzi (FAQ)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Moduł do zarządania opiniami',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Indywidualne przypisanie darmowej wysyłki',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Obsługa klienta i panelu',
            name: 'Czarna lista klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Wbudowany system zarządzania magazynem (WMS) ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Obsługa wielu magazynów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Informacje o stanach magazynowych ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Dokumenty magazynowe (WZ, PZ, MM, RW itp.)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Dostawa z kilku magazynów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Lokalizacje w magazynach',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Integracja danych do systemu ERP',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Lista towarów do spakowania',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Baza produktów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Narzędzia do weryfikacji zamówień',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Moduł inwentaryzacji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Magazyny',
            name: 'Integracja z fulfillment',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Pełna integracja z kurierami',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Automaty paczkowe i punkty odbioru',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Odbiór osobisty',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Wybór opcji dostaw',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Obsługa wielu adresów dostawy',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Automatyzacja wydruku etykiet i przepływu zamówień',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Automatyczne generowanie numerów przesyłek oraz wydruków dla kuriera',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Generowanie i drukowanie faktur i etykiet wysyłki',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Udostępnienie klientowi numeru listu przewozowego',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Wysyłka zamówienia w kilku paczkach',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Zarządzanie czasem wysyłki',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Darmowa dostawa od wskazanej kwoty ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Logistyka',
            name: 'Przekazanie statusu realizacji zamówienia',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Zwroty i reklamacje',
            name: 'Zaawansowany moduł do zwrotów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Zwroty i reklamacje',
            name: 'Rozbudowany moduł do reklamacji ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Zwroty i reklamacje',
            name: 'Zarządzanie zwrotami ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Zwroty i reklamacje',
            name: 'Generowanie etykiet zwrotów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Zwroty i reklamacje',
            name: 'Monitorowanie statusu zwrotów i reklamacji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Wbudowany system płatności IdoPay',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Integracje z zewnętrznymi systemami płatności',
            values: {
                START: Minus,
                BUSINESS: Minus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Automatyczne zarządzanie płatnościami za zamówienia',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Automatyczne wystawianie i wysyłanie faktur',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Automatyczne księgowanie płatności',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'E-faktura',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Stawki VAT',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Możliwość generowania plików JPK',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Płatności i rozliczenia',
            name: 'Wydruk dokumentów sprzedaży, faktur i paragonów fiskalnych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Zaawansowany moduł do promocji ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Kupony i kody rabatowe',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Możliwość śledzenia efektywności promocji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Rekomendowane produkty',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Prezentacja produktów powiązanych ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Zestawy produktowe',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Integracja z narzędziami Google tj. Analytics 4, Ads, Maps',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Ustawianie parametrów SEO produktów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Pełna integracja z Facebook (m.in. Product Ads, Katalog Produktów)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Możliwość zbierania zgód marketingowych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Narzędzia do automatyzacji marketingu (porzucone koszyki, personalizowane e-maile)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Wysyłka newslettera do klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Marketing',
            name: 'Program lojalnościowy oraz partnerski',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Statystyki i analityka',
            name: 'Moduł raportów i analityki sprzedaży',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Statystyki i analityka',
            name: 'Raport menadżerski',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Statystyki i analityka',
            name: 'Analiza danych dotyczących klientów ',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Statystyki i analityka',
            name: 'Raport monitorowania pracy pracowników',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Bezpieczeństwo',
            name: 'Dostęponość sklepów na poziomie 99,98% (SLA)',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Bezpieczeństwo',
            name: 'Pomoc techniczna dostępna 24/7',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Bezpieczeństwo',
            name: 'Pełna i zawsze aktualna wersja systemu',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Bezpieczeństwo',
            name: 'Gotowy regulamin sklepu zgodny z wymogami prawnymi',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Bezpieczeństwo',
            name: 'Szablon sklepu zgodny z dyrektywą Omnibus',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'Bezpieczeństwo',
            name: 'Zgoda na pliki cookies zgodna z prawem UE i RODO',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Dedykowany szablon B2B',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Udostępnianie strony tylko zalogowanym klientom - hurtownia „zamknięta”',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Akceptacja zamówień od wielu użytkowników w jednej firmie ',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Dowolność zarządzania asortymentem sklepu i polityką cenową dla różnych grup klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Cenniki indywidualne dla klientów hurtowni',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Odrębne ceny towarów dla sprzedaży detalicznej i hurtowej',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Odrębne profile płatności i dostaw dla klientów hurtowych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Odrębne progi/grupy rabatowe dla klientów',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Prezentowanie cen netto/brutto i ukrycie ich dla klientów niezalogowanych',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Oznaczenie klienta jako hurtownika',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Przypisywanie opiekuna handlowego',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Tworzenie oferty w pdf dla kontrahenta',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Udostępnianie oferty do integracji dla klienta',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Lista produktów wcześniej zamawianych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Listy produktów poszukiwanych i oczekiwanych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Dodawanie do koszyka produktów po kodzie producenta lub z pliku csv',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Minimum logistyczne dla zamówień hurtowych',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Wystawianie faktury zbiorczej na koniec miesiąca',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Dropshipping i cross-docking przez tzw. Customer API',
            values: {
                START: Minus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Historia zamówień i transakcji',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
        {
            category: 'B2B',
            name: 'Moduł aktualności',
            values: {
                START: Plus,
                BUSINESS: Plus,
                EXPERT: Plus,
                ENTERPRISE: Plus,
                INDIVIDUAL: Plus,
            },
        },
    ];
    return (
        <Box {...props}>
            <TableSection
                title="Informacje dodatkowe o abonamentach"
                valuesName={valuesName}
                mainCategories={mainCategories}
                tableSection={tableSection}
                tableColumns={5}
            />
        </Box>
    );
};
